<template>
    <div>
        <vue-autosuggest
            ref="autosuggest"
            v-model="query"
            :class="validateError != '' ? 'box-border-color' : ''"
            :suggestions="suggestions"
            :inputProps="inputProps"
            :sectionConfigs="sectionConfigs"
            :getSuggestionValue="getSuggestionValue"
            @input="handleInput">
            <template v-slot="{ suggestion }">
                <div>{{ suggestion.item.student_number + ' ' + suggestion.item.name + ' ' + suggestion.item.surname }}</div>
            </template>
        </vue-autosuggest>
        <span class="invalid-feedback-custom" v-show="validateError" v-html="validateError"/>
    </div>
</template>

<script>
import StudentService from "@/services/StudentService";
import qs from "qs";

export default {
    props: {
        value: {
            default: null
        },
        validateError: {
            type: String,
            default: ''
        },
        studentType: {
            type: String,
            default: 'bau'
        },
        valueObject: {
            type: Object,
            default: null
        },
        clear:{
          type: Boolean,
          default: false
        }
    },

    data() {
        return {
            query: "",
            data: [],
            timeout: null,
            debounceMilliseconds: 200,
            inputProps: {
                id: "autosuggest__input",
                placeholder: `${this.$t('search')} ...`,
                class: "form-control"
            },
            sectionConfigs: {
                limit: 10,
                default: {
                    onSelected: (suggestion) => {
                        if (suggestion) {
                            this.handleSelection(suggestion);
                        }
                    }
                }
            }
        };
    },

    computed: {
        suggestions() {
            return [
                {
                    data: this.data
                }
            ];
        }
    },
    watch: {
        valueObject: {
            handler(newVal) {
                if (newVal && newVal.value && newVal.text) {
                    this.query = newVal.text;
                    const found = this.data.find(
                        item => item.student_number == newVal.value
                    );
                    if (found) {
                        this.handleSelection(found);
                    } else {
                        this.$emit('user-input', {
                            student_number: newVal.value,
                            ...newVal
                        });
                    }
                } else if (!newVal) {
                    this.query = "";
                    this.$emit('user-input', null);
                }
            },
            immediate: true
        },
        clear(newVal) {
                this.query = "";

        }

    },

    methods: {
        getSuggestionValue(suggestion) {
            return `${suggestion.item.student_number} ${suggestion.item.name} ${suggestion.item.surname}`;
        },

        handleInput(query) {
            this.query = query;
            if (query.length < 3) {
                this.data = [];
                return;
            }

            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
                const config = {
                    params: {
                        student_type: this.studentType,
                        key: query
                    },
                    paramsSerializer: (params) => qs.stringify(params, { encode: false })
                };

                StudentService.search(config)
                    .then((response) => {
                        this.data = response.data.data || [];
                    })
                    .catch(() => {
                        this.data = [];
                    });
            }, this.debounceMilliseconds);
        },

        handleSelection({item}) {
            this.$emit('user-input', item);
            this.query = `${item.student_number} ${item.name} ${item.surname}`;
        }
    }
};
</script>
